// 同一ページ内リンクと、別ページから遷移した初期ハッシュの位置を揃える。
export function initSmoothScroll({ headerOffset = null } = {}) {
  const getTarget = (hash) => {
    if (!hash || hash === '#') return null;

    try {
      return document.getElementById(decodeURIComponent(hash.slice(1)));
    } catch (_) {
      return null;
    }
  };

  const getOffset = () => {
    if (Number.isFinite(headerOffset)) return headerOffset;

    const scrollPaddingTop = parseFloat(
      window.getComputedStyle(document.documentElement).scrollPaddingTop
    );
    return Number.isFinite(scrollPaddingTop) ? scrollPaddingTop : 0;
  };

  const scrollToTarget = (target, behavior) => {
    const top = Math.max(
      0,
      target.getBoundingClientRect().top + window.scrollY - getOffset()
    );
    window.scrollTo({ top, behavior });
  };

  document.querySelectorAll('a[href]').forEach((a) => {
    a.addEventListener('click', (e) => {
      const href = a.getAttribute('href');
      if (
        !href
        || e.defaultPrevented
        || e.button !== 0
        || e.metaKey
        || e.ctrlKey
        || e.shiftKey
        || e.altKey
      ) return;

      let url;
      try {
        url = new URL(href, window.location.href);
      } catch (_) {
        return;
      }

      const isCurrentPage = url.origin === window.location.origin
        && url.pathname === window.location.pathname
        && url.search === window.location.search;
      if (!isCurrentPage) return;

      const target = getTarget(url.hash);
      if (!target) return;

      e.preventDefault();
      if (window.location.hash !== url.hash) {
        window.history.pushState(null, '', url.hash);
      }
      scrollToTarget(target, 'smooth');
    });
  });

  const correctInitialHashPosition = () => {
    const target = getTarget(window.location.hash);
    if (!target) return;

    const correct = () => {
      window.requestAnimationFrame(() => {
        window.requestAnimationFrame(() => scrollToTarget(target, 'auto'));
      });
    };

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(correct, correct);
    } else {
      correct();
    }
  };

  if (document.readyState === 'complete') {
    correctInitialHashPosition();
  } else {
    window.addEventListener('load', correctInitialHashPosition, { once: true });
  }
}
